export const PAGE_TITLE = {
  // pps
  applicant: 'We need more information about the applicant',
  property: 'We need more information about your property',
  conveyancer: 'Please give us details about your conveyancer',
  accountant: "Please give us details about the applicant's accountant",
  accountDetails: 'Provide your account details',

  // guarantor
  borrowerPostProductSummary: "Borrowers' postProducts",
  guarantorPostProductSummary: "Guarantors' postProducts",
};
